import {clientGetWrapper} from "../api/Api";
import {GET_ADVERTISER_PENDING_ASSETS} from "../common/constants/routes";


export const getAdvertiserPendingAssets = () => {
    return clientGetWrapper(GET_ADVERTISER_PENDING_ASSETS);
}
